export default () => ({
    countries: []
})
